import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_p4a82gaf2t: FaireBrandEntity = {
  token: "b_p4a82gaf2t",
  type: "brand",
  name: "Elemental Earth Shop",
  avatarUrl:
    "https://cdn.faire.com/fastly/07e51652e213b774828bae2a971d633a71fa8ce8724a64a60c6316aac3d0d54f.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/37caba4eed22a365de0368bf84e50f4ebec40b61dcee1a1f9f72efbd63356f89.png",
  logoUrl:
    "https://cdn.faire.com/fastly/07e51652e213b774828bae2a971d633a71fa8ce8724a64a60c6316aac3d0d54f.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/37caba4eed22a365de0368bf84e50f4ebec40b61dcee1a1f9f72efbd63356f89.png",
  location: "Tecumseh, OK, USA",
  minimumOrderDollars: 100,
  rating: 5,
  reviewCount: 80,
  isTopShop: true,
  isInsider: true,
  description:
    "If you're looking for weak smelling candles, you've come to the WRONG place! Our paraffin tapers are dressed with maximum scent, organic herbs and flowers, and the strongest intentions.\n\nOur small business was founded by a woman with a love for flowers, plants and herbs. Driven by a passion for weaving, making, and the magic of nature, Elemental Earth Shop was born.  Every piece we offer is a reminder that the earth's elements can bring peace, positivity, and a touch of magic into our daily lives. At Elemental Earth Shop, we believe in the power of intentions, the beauty of nature, and the joy of creation.",
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:51:46.084Z",
    importedBy: "entity-db-cli",
  },
};
